import { fastTradeGameService } from '../fastTradeService/gameService';
import { detectSocketPath } from '../../../core/constants/socketPathName';
import { environmentBuilder } from '../../../core/helpers/environmentBuilder';
import { mainGameConnection } from '../../../core/mainGameConnection/mainGameConnection';

export class FastTradeGameConnection {
  executeGameConnections() {
    mainGameConnection.onGetInitialStateResult(
      fastTradeGameService.onGetInitialStateResult.bind(fastTradeGameService)
    );
    mainGameConnection.onDoBetResult(
      fastTradeGameService.handleDoBetResult.bind(fastTradeGameService)
    );
    mainGameConnection.onDoBetResultValidation(
      fastTradeGameService.handleDoBetResultValidation.bind(fastTradeGameService)
    );
    mainGameConnection.onRoundFinished(
      fastTradeGameService.handleRoundFinished.bind(fastTradeGameService)
    );
    mainGameConnection.onFreeBetEnded(
      fastTradeGameService.handleFreeBetEnded.bind(fastTradeGameService)
    );
    mainGameConnection.onRoundStarted(
      fastTradeGameService.handleRoundStart.bind(fastTradeGameService)
    );
    mainGameConnection.onResultReport(
      fastTradeGameService.handleResultReport.bind(fastTradeGameService)
    );
    mainGameConnection.onBetsClosed(
      fastTradeGameService.handleBetsClosed.bind(fastTradeGameService)
    );
  }
}

const { socketUrl } = environmentBuilder(detectSocketPath(window.location.pathname));

export const fastTradeGameConnection = new FastTradeGameConnection({ url: `${socketUrl}game` });
